export default () => {
  return `
    html,body{
        display: flex;
        flex-direction: column;
        height: 100%;
        min-height: 100%;
    }
    #root{
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
    }
    body, #root{
        flex-grow: 1;
    }

    @media screen and (max-width: 768px) {
      body{
        height: 100vh;
        min-height: 100vh;
        overflow: auto;
      }
    }
    
  `
}
